const i18n = {
	saveReportPattern: {
		1 : "Сохранить шаблон",
		0 : "Захаваць шаблон"
	},
	reOrgPlaceholder: {
		0 : "Арганізацыя",
		1 : "Организация"
	},
	addNewColumn: {
		1 : "Добавить колонку",
		0 : "Дадаць калонку"
	},
	addNewRow: {
		1 : "Добавить строку",
		0 : "Дадаць радок"
	},
	columnNum: {
		0 : "Калонка {0}",
		1 : "Колонка {0}"
	},
	rowNum: {
		0 : "Радок {0}",
		1 : "Строка {0}"
	},
	parameterBasePlaceholder: {
		1 : "Название параметра",
		0 : "Назва параметра"
	},
	meaningBasePlaceholder: {
		1 : "Значение параметра",
		0 : "Значэнне параметра"
	},
	emptyDateFieldMessage: {
		1 : "Установите временные рамки отчета",
		0 : "Усталюйце часовыя рамкі справаздачы"
	},
	emptyReOrgFieldMessage: {
		1 : "Выберите организацию",
		0 : "Абярыце арганізацыю"
	},
	emptyNameFieldMessage: {
		1 : "Название обязательно для заполнения",
		0 : "Назва абавязковая для запаўнення"
	},
	maxAllowedLength: {
		1 : "Максимальная допустимая длина {0} символов",
		0 : "Максімальная дапушчальная даўжыня {0} сімвалаў"
	},
	nameFieldPlaceholder: {
		1 : "Название шаблона на русском языке",
		0 : "Назва шаблону на рускай мове"
	},
	nameBelFieldPlaceholder: {
		1 : "Название шаблона на белорусском языке",
		0 : "Назва шаблону на беларускай мове"
	},
	compareToPreviousYear: {
		1: "% по сравнению с аналогичным периодом прошлого года",
		0: "% у параўнанні з аналагічным перыядам мінулага года"
	},
	saveAsNewTemplate: {
		1 : "Сохранить как шаблон",
		0 : "Захаваць як шаблон"
	},
	downloadReport: {
		1 : "Скачать отчет",
		0 : "Спампаваць справаздачу"
	},
	removeTemplate: {
		1 : "Удалить шаблон",
		0 : "Выдаліць шаблон"
	},
	yes : {
		1 : "Да",
		0 : "Так"
	},
	no : {
		1 : "Нет",
		0 : "Не"
	},
	sureWantToDeleteTemplate: {
		1 : "Вы уверены, что хотите удалить шаблон",
		0 : "Вы ўпэўненыя, што жадаеце выдаліць шаблон"
	},
	saveTemplate: {
		1 : "Сохранить",
		0 : "Захавать"
	},
	enterTemplateName:{
		1 : "Введите название шаблона",
		0 : "Увядзіце назву шаблону"
	},
	templateRemoveSuccess:{
		1 : "Шаблон успешно удален",
		0 : "Шаблон паспяхова выдалены"
	},
	templateAddSuccess:{
		1 : "Шаблон успешно добавлен",
		0 : "Шаблон паспяхова дададзены"
	},
	templateUpdateSuccess:{
		1 : "Шаблон успешно изменен",
		0 : "Шаблон паспяхова зменены"
	},
	noChangesSet: {
		1 : "Не было внесено новых изменений",
		0 : "Не было занесена новых змен"
	},
	chooseParam: {
		1 : "Выберите параметр",
		0 : "Абярыце параметр"
	},
	chooseParamValue: {
		1 : "Выберите значения параметра",
		0 : "Абярыце значэнні параметру"
	},
	appealTypePlaceholder: {
		1 : "Выберите тип обращения",
		0 : "Абярыце тып звароту"
	},
	appealFormTypePlaceholder: {
		1 : "Выберите формы подачи обращения",
		0 : "Абярыце формы падачы звароту"
	},
	appealViewTypePlaceholder: {
		1 : "Выберите вид обращения",
		0 : "Абярыце від звароту"
	},
	applicantTypePlaceholder: {
		1 : "Выберите тип заявителя",
		0 : "Абярыце тып заяўніка"
	},
	themePlaceholder: {
		1 : "Выберите тему обращения",
		0 : "Абярыце тэму звароту"
	},
	subthemePlaceholder: {
		1 : "Выберите подтему обращения",
		0 : "Абярыце падтэму звароту",
	},
	reOrgAppealStatusPlaceholder: {
		1 : "Выберите статус обращения",
		0 : "Абярыце статус звароту",
	},
	reOrgAppealTerritoriesPlaceholder: {
		1 : "Выберите районы",
		0 : "Абярыце раёны",
	},
	regionsPlaceholder: {
		1 : "Выберите регионы",
		0 : "Абярыце рэгіёны",
	},
	districtsPlaceholder: {
		1 : "Выберите районы",
		0 : "Абярыце раёны",
	},
	regionCitiesPlaceholder: {
		1 : "Выберите города областного подчинения",
		0 : "Абярыце гарады абласнога падпарадкавання",
	},
	superiorOrgsPlaceholder: {
		1 : "Выберите вышестоящую организацию",
		0 : "Абярыце вышэйстаячую арганізацыю",
	},
	receptionPersonPlaceholder: {
		1 : "Выберите лицо, проводившее личный прием",
		0 : "Абярыце асобу, якая праводзіла асабісты прыём"
	},
	controlCompleteStatusesPlaceholder: {
		1 : "Выберите решение по обращения",
		0 : "Абярыце рашэнне па звароту"
	},
	reportFromTo: {
		1 : 'Отчет c {0} по {1}',
		0 : 'Справаздача з {0} па {1}',
	},
	isUnderControl: {
		1 : 'Обращения на контроле',
		0 : 'Звароты на кантролі'
	},
	all: {
		1 : "Все",
		0 : "Усе"
	}
}
export default i18n
